import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3f5325bf"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./config/app-reset.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "@/config/element-ui-reset.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports